import { render, staticRenderFns } from "./VetCreate.vue?vue&type=template&id=3909e808&"
import script from "./VetCreate.vue?vue&type=script&lang=js&"
export * from "./VetCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports